import { checkFilterMatch } from './helpers';

export class ComboboxStandardDataProvider {
    constructor(options) {
        /** @type {Object[]} */
        this.options = options
            ? options 
            : [];
    }

    setOptions(items) {
        this.options = items;
    }

    getOptions(searchText = undefined) {
        if (searchText) {
            const filtered = this.options.filter(e => checkFilterMatch(e.label, searchText));
            return filtered;
        }
        return this.options;
    }

    createNewItem(strValue) {
        const item = {
            value: Math.random().toString(36),
            label: strValue
        };
        this.options.push(item);
        return item;
    }

    getNameById(id) {
        const resultItem = this.options.find(e => e.value === id);
        return resultItem ? resultItem.label : undefined;
    }
}
